export default "__VITE_ASSET__B2z0iK3a__"